module.exports = "<template> <div class=tyl-view-switcher part=root> <slot></slot> </div> </template>";